import { render } from "./taskdetails.vue?vue&type=template&id=7c6d6a19"
import script from "./taskdetails.vue?vue&type=script&lang=js"
export * from "./taskdetails.vue?vue&type=script&lang=js"

import "./taskdetails.vue?vue&type=style&index=0&id=7c6d6a19&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__